import 'dibs-buyer-layout/exports/error404.tsx';
import { initializeDBL } from 'dibs-buyer-layout/src/entries/index.jsx';
import * as tracking from 'dibs-tracking';

initializeDBL();

window.dataLayer.push({
    event: 'e_server_error',
    httpStatusCode: 404,
    pageRequestOrigin: document.location.href,
    pageRequestReferrer: document.referrer,
});

tracking.trackPageview({});
